import { useEffect, useState } from "react";
import "./App.css";
import "./style.css";
import supabase from "./supabase";
import CategoryFilter from "./components/category-filter";
import Header from "./components/header";
// import { INITIALFACTS } from "./components/initialfacts";
import Footer from "./components/footer";
import FactForm from "./components/fact-form";
import FactList from "./components/fact-list";
import Counter from "./components/test-counter";
import Loader from "./components/loader";




function App() {
  let [ showForm, setShowForm ] = useState(false)
  let [ isLoading, setIsLoading ] = useState(false)
  // let [ facts, setFacts ] = useState(INITIALFACTS)
  let [ facts, setFacts ] = useState([])
  let [ currentCategory, setCurrentCategory ] = useState("all")

  // Original query to access everything without category filtering...
  // useEffect(function() {
  //   async function getFacts() {
  //     setIsLoading(true)
  //     let { data: facts, error } = await supabase
  //     .from('facts')
  //     .select('*')
  //     .eq("category", "technology")
  //     .order('created_at', {descending: true})
  //     .limit(20);
  //     // console.log(facts)
  //     if (!error) {
  //       setFacts(facts)
  //       setIsLoading(false)
  //     } else {
  //       console.log("Error fetching database data: ", error)
  //       alert("Error fetching database data!")
  //     }
  //   }
  //   getFacts()
  // }, [])


  // Modified query construction for category filtering...
  useEffect(function() {
    async function getFacts() {
      setIsLoading(true)

      let query = supabase.from('facts').select('*')

      if (currentCategory !== "all") query = query.eq("category", currentCategory)

      let { data: facts, error } = await query
        .order('created_at', {descending: true})
        .limit(20)

      if (!error) {
        setFacts(facts)
        setIsLoading(false)
      } else {
        console.log("Error fetching database data: ", error)
        alert("Error fetching database data!")
      }
    }
    getFacts()
  }, [currentCategory])

  return (
    <>
    <div id="root">
     
    <div className="App container">
      <Header showForm={showForm} setShowForm={setShowForm} />

    
      <main>

        <section className="text-left">
          <h3>Facts & Categories</h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque aliquam quasi nobis inventore autem ex, voluptas non exercitationem ipsum nostrum ea incidunt.
            Fugiat repellendus nobis harum, deleniti amet blanditiis aperiam!</p>
        </section>

        <section>
          { showForm ? <FactForm setFacts={setFacts} setShowForm={setShowForm} /> : null }
        </section>

        <section>
          <hr></hr>

          <section id="middle-section">

            <section>
              <CategoryFilter setCurrentCategory={setCurrentCategory} />
            </section>
          
            <section id="fact-list">
              {isLoading ? <Loader /> : <FactList facts={facts} setFacts={setFacts} /> }
            </section>

          </section>

          <hr></hr>

        </section>

      </main>

      <Counter />

      <Footer />
    </div>
    </div>
    
    </>
  );
}

export default App;
